import { CLEAR_AFFILIATION, GET_AFFILIATES } from '../../actions/types';

const initialState = { isLoading: true };

const affiliates = (state = initialState, { type, data }) => {
  switch (type) {
    case GET_AFFILIATES:
      return {
        ...state,
        isLoading: false,
        affiliatesChart: data.transactionsChart,
        affiliates: data.affiliates,
        user: data.user,
        wallet: data.wallets,
      };
    case CLEAR_AFFILIATION:
      return {
        isLoading: true,
      };
    default: {
      return state;
    }
  }
};
export default affiliates;
